<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="10">
          <a-col :md="6" :sm="24">
            <a-form-item label="Query">
              <a-input v-model="queryParam.query" placeholder="Code/Name" @keyup.enter.stop="refreshCurrentPage"/>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="City">
              <a-select
                v-model="queryParam.countryId"
                show-search
                placeholder="Select a city"
                option-filter-prop="children"
                :filter-option="(input, option) => {
                  return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0)
                }"
              >
                <a-select-option value="">All</a-select-option>
                <a-select-option v-for="c in cities" :key="c.id" :value="c.id">{{ c.nameEnUs }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="Status">
              <a-select v-model="queryParam.enabledFlag" placeholder="Please select" default-value="0" @change="refreshCurrentPage">
                <a-select-option value="">All</a-select-option>
                <a-select-option value="1">Enabled</a-select-option>
                <a-select-option value="0">Disabled</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="$refs.table.refresh(true)">Search</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = { query: '', enabledFlag: '1', cityId: '' }">Clear</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleEdit()" :disabled="!$auth('BD_SUPPLIER_ADD')">New</a-button>
    </div>

    <s-table
      ref="table"
      size="default"
      rowKey="id"
      showQuickJumper
      :columns="columns"
      :data="loadData"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="enabledFlag" slot-scope="text">
        {{ text === '1' ? 'Yes' : 'No' }}
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleEdit(record)" :disabled="!$auth('BD_SUPPLIER_EDIT')">Edit</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="Are you sure delete this role?"
            @confirm="onDeleteConfirmed(record)"
            okText="Yes"
            cancelText="No"
            :disabled="!$auth('BD_SUPPLIER_DELETE')"
          >
            <a href="javascript:;">Delete</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
  </div>
</template>

<script>
import moment from 'moment'
import STable from '@/components/table/'
import { toSTablePage } from '@/utils/util'
import SupplierApi from '@/api/basicdata/api-supplier'

export default {
  name: 'SupplierList',
  components: {
    STable
  },
  props: {
    cities: {
      type: [Array],
      required: true
    },
  },
  data () {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: { query: '', enabledFlag: '1', cityId: '' },
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: 'Name',
          dataIndex: 'nameEnUs'
        },
        {
          title: 'City',
          dataIndex: 'cityId',
          customRender: (value) => {
            const city = this.cities.filter(c => {
              return c.id == value
            })[0]
            if (city) {
              return city.nameEnUs
            } else {
              return null
            }
          }
        },
        {
          title: 'Enabled',
          dataIndex: 'enabledFlag',
          scopedSlots: { customRender: 'enabledFlag' }
        },
        {
          title: 'Change By',
          dataIndex: 'changeBy',
          customRender: (value) => value ? value.userName : ''
        },
        {
          title: 'Change Time',
          dataIndex: 'writeDate',
          customRender: (value, record) => this.DateTimeUtil().localString(value !== null ? value : record.createDate)
        },
        {
          title: 'Action',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        parameter.curPage = parameter.pageNo
        return SupplierApi.query(Object.assign(parameter, this.queryParam))
          .then(res => {
            return toSTablePage(res.data)
          })
      },
      selectedRowKeys: [],
      selectedRows: []
    }
  },
  created () {
  },
  methods: {
    handleEdit (record) {
      this.$emit('onEdit', record)
    },
    // 点击确认删除按钮
    onDeleteConfirmed (recode) {
      const params = { 'ids': [recode.id] }
      const that = this
      SupplierApi.delete(params).then(res => {
        if (!that.mixinProcessHasBizErrorNotification(res)) {
          that.mixinProcessSuccessNotification('Delete successfully !')
          that.$refs.table.refresh(true)
        }
      })
    },
    handleOk () {
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    refreshCurrentPage () {
      this.$refs.table.refresh(false)
    },
    resetSearchForm () {
      this.queryParam = {
        date: moment(new Date())
      }
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.currentComponet = 'List'
    }
  }
}
</script>
